import type { IconGlyph } from './icon';

/**
 * A glyph as a CSS mask image, for icons drawn by CSS, such as the check in a
 * switch track. The mask takes the shape, and `background-color` gives the
 * colour.
 */
export function glyphMask(glyph: IconGlyph): string {
  const viewBox = glyph.viewBox ?? 24;
  const paths = typeof glyph.path === 'string' ? [glyph.path] : glyph.path;
  const fillRule = glyph.fillRule ?? 'nonzero';
  const pathElements = paths
    .map(d => `<path fill-rule='${fillRule}' d='${d}'/>`)
    .join('');
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 ${viewBox} ${viewBox}'>${pathElements}</svg>`;
  return `url("data:image/svg+xml,${encodeURIComponent(svg)}")`;
}
